import {
  esk900FnCommonNav,
  esk900MediaKeys,
  fnFRowStandard,
  sideLedMediaKeys,
  type FactoryKeyMap,
  type KeysConfig,
} from './common'

const factoryKeysWin: FactoryKeyMap = {
  ...fnFRowStandard,
  ...esk900FnCommonNav,
  Delete: 'SideLED_Color',
  Tab: 'SideLED_Mode',
  '|_\\': 'SideLED',
}

export const esk90098Keys: KeysConfig = {
  factoryKeys: {
    win: factoryKeysWin,
    mac: { ...factoryKeysWin },
  },
  mediaKeys: [...esk900MediaKeys, ...sideLedMediaKeys],
}
